module.exports = __webpack_public_path__ + "static/media/Kent Brockman.e87c85d8.png";